import { goTo } from '../../actions/routing';
import config from '../../config';
import { muleSoftFetch } from '../../utils/fetch';
import { parseQueryString } from '../../utils/queryString';
import { POLICY_TYPES, FEATURE_CODES, POLICY_TYPE_CODES } from '../../constants/constants';
import { getShouldShowUsernameField } from '../../utils/helpers';
import { getErrorConfig } from '../../utils/error-code';

const INITIAL = 'INITIAL';
const EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START =
  'EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START';
const EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE =
  'EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE';
const EMMA_RETRIEVE_ACCOUNT_SUCCESS = 'EMMA_RETRIEVE_ACCOUNT_SUCCESS';
const EMMA_RETRIEVE_ACCOUNT_SUCCESS_MULTI_CONTACT = 'EMMA_RETRIEVE_ACCOUNT_SUCCESS_MULTI_CONTACT';
const EMMA_RETRIEVE_ACCOUNT_FAIL = 'EMMA_RETRIEVE_ACCOUNT_FAIL';
const EMMA_RETRIEVE_ACCOUNT_CARD_TYPE_SEL =
  'EMMA_RETRIEVE_ACCOUNT_CARD_TYPE_SEL';
const EMMA_RETRIEVE_ACCOUNT_POLICY_TYPE_SEL =
  'EMMA_RETRIEVE_ACCOUNT_POLICY_TYPE_SEL';
const EMMA_RETRIEVE_ACCOUNT_RESET_SUCCESS = 'EMMA_RETRIEVE_ACCOUNT_RESET_SUCCESS';
const EMMA_RETRIEVE_ACCOUNT_RESET_FAIL = 'EMMA_RETRIEVE_ACCOUNT_RESET_FAIL';
const EM_RETRIEVE_ACCOUNT_POLICYTYPE_SEL = 'EM_RETRIEVE_ACCOUNT_POLICYTYPE_SEL';
const EM_RETRIEVE_ACCOUNT_GOTO_REVIEW = 'EM_RETRIEVE_ACCOUNT_GOTO_REVIEW';
const EM_RETRIEVE_ACCOUNT_FROM_CHANGED = 'EM_RETRIEVE_ACCOUNT_FROM_CHANGED';
const EM_RETRIEVE_ACCOUNT_REVIEW_BACK = 'EM_RETRIEVE_ACCOUNT_REVIEW_BACK';
const EM_RETRIEVE_ACCOUNT_USE_OTHER_USERNAME = 'EM_RETRIEVE_ACCOUNT_USE_OTHER_USERNAME';

const initialState = {
  axaId: '',
  loginId: '',
  policyType: '',
  cardType: '',
  isSubmitting: false,
  isSuccess: false,
  hash: '',
  errorCode: '',
  emails: '',
  mobiles: '',
  showForReview: {},
  submitValues: {},
  fromPage: '',
  isShowForReview: false,
  submitHandler: null,
  email: '',
  contactType: '',
  countryCode: '',
  mobile: '',
  emailMap: [],
  countryCodeMap: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIAL:
      return {
        ...state,
        isSubmitting: false,
        isShowForReview: false,
      };
    case EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START:
      return {
        ...state,
        isSubmitting: true,
      };
    case EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE:
      return {
        ...state,
        isSubmitting: false,
      };
    case EMMA_RETRIEVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        hash: action.hash,
        isSuccess: true,
      };
    case EMMA_RETRIEVE_ACCOUNT_SUCCESS_MULTI_CONTACT:
      return {
        ...state,
        hash: action.hash,
        emails: action.emails,
        mobiles: action.mobiles,
        isEmailsUsed: action.isEmailsUsed,
        isMobilesUsed: action.isMobilesUsed,
        loginId: action.loginId,
        policyType: action.policyType,
        isSubmitting: false,
        isSuccess: true,
        emailMap: action.emailMap,
        countryCodeMap: action.countryCodeMap,
        insuredAccessFlag: action.insuredAccessFlag,
        selectContactFlag: action.selectContactFlag,
        lobs: action.lobs,
      };
    case EMMA_RETRIEVE_ACCOUNT_FAIL:
      return {
        ...state,
        isSuccess: false,
        axaId: action.axaId,
        loginId: action.loginId,
        errorCode: action.errorCode,
        policyType: action.policyType,
        payload: action.payload ? action.payload : null,
      };
    case EMMA_RETRIEVE_ACCOUNT_CARD_TYPE_SEL:
      return {
        ...state,
        cardType: action.cardType,
      };
    case EMMA_RETRIEVE_ACCOUNT_POLICY_TYPE_SEL:
      return {
        ...state,
        policyType: action.policyType,
      };
    case EMMA_RETRIEVE_ACCOUNT_RESET_SUCCESS:
      return {
        ...state,
        isSuccess: true,
        loginId: action.loginId,
        contactType: action.contactType,
      };
    case EMMA_RETRIEVE_ACCOUNT_RESET_FAIL:
      return {
        ...state,
        isSuccess: false,
        errorCode: action.errorCode,
        formUrl: action.formUrl,
      };
    case EM_RETRIEVE_ACCOUNT_POLICYTYPE_SEL:
      return {
        ...state,
        policyType: action.policyType,
      };
    case EM_RETRIEVE_ACCOUNT_GOTO_REVIEW:
      return {
        ...state,
        showForReview: action.showForReview,
        submitValues: action.submitValues,
        fromPage: action.fromPage,
        submitHandler: action.submitHandler,
      };
    case EM_RETRIEVE_ACCOUNT_REVIEW_BACK:
      return {
        ...state,
        isShowForReview: true,
      };
    case EM_RETRIEVE_ACCOUNT_USE_OTHER_USERNAME:
      return {
        ...state,
        emails: action.emails,
        mobiles: action.mobiles,
      };
    case EM_RETRIEVE_ACCOUNT_FROM_CHANGED:
      return {
        ...state,
        fromPage: action.fromPage,
      };
    default:
      return state;
  }
}

export const initial = () => {
  return (dispatch) => {
    dispatch({
      type: INITIAL,
    });
  };
};

export const redirectOnPolicyTypeSel = (policytype) => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EM_RETRIEVE_ACCOUNT_POLICYTYPE_SEL,
      policyType: policytype,
    });
    if (policytype === 'individual') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/individual-policy-selection`));
    } else if (policytype === 'company') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/company-policy-selection`));
    } else if (policytype === 'pnc') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/pnc-policy-selection`));
    } else {
      // console.error(`Unexpected policytype ${policytype}`);
    }
  };
};

export const selectPolicyType = (policyType) => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EMMA_RETRIEVE_ACCOUNT_POLICY_TYPE_SEL,
      policyType,
    });
    if (policyType === 'individual') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/individual-policy`));
    } else if (policyType === 'company') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/company-policy-selection`));
    }
  };
};

export const selectCardType = (cardType) => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EMMA_RETRIEVE_ACCOUNT_CARD_TYPE_SEL,
      cardType,
    });
    if (cardType === 'axa') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/axa-card`));
    } else if (cardType === 'other') {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/other-card`));
    }
  };
};

export const goToReviewInformation = (showForReview, submitValues, fromPage, submitHandler) => {
  return (dispatch, getState) => {
    dispatch({
      type: EM_RETRIEVE_ACCOUNT_GOTO_REVIEW,
      showForReview,
      submitValues,
      fromPage,
      submitHandler,
    });
    const currLang = getState().language.lang;
    dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/review-information?fromPage=${encodeURIComponent(fromPage)}`));
  };
};

export const changeFromPage = (fromPage) => {
  return (dispatch) => {
    dispatch({
      type: EM_RETRIEVE_ACCOUNT_FROM_CHANGED,
      fromPage,
    });
  };
};

export const onReviewBackIconClick = (url) => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    const fromPageUrl = url || getState().emmaRetrieveAccount.fromPage;
    if (fromPageUrl) {
      dispatch({
        type: EM_RETRIEVE_ACCOUNT_REVIEW_BACK,
      });
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/${fromPageUrl}`));
      dispatch({ type: EM_RETRIEVE_ACCOUNT_FROM_CHANGED, fromPage: '' });
    }
  };
};


export function mapFeToApiField(submitValues) {
  let {
    dob = '', // Deprecated
    policy = '', // Deprecated
    cardType = '', // Deprecated
  } = submitValues;
  const {
    hkId = '', // Deprecated
    passport = '', // Deprecated
    chinaid = '', // Deprecated
    cert = '', // Deprecated
    dependent = '', // Deprecated
    member = '', // Deprecated
    dateOfBirth = '', // Deprecated

    policyNumber = '', // Deprecated
    dependentNumber = '', // Deprecated
    certificateNumber = '', // Deprecated
    membershipNumber = '', // Deprecated
  } = submitValues;

  // new standardized attributes
  // captchaToken: "03AGdBq2..."
  // documentDob: "20190202"
  // documentID: "123456789"
  // documentType: "passport"
  // policyNo: "12345678"
  // policyType: "pnc"
  const {
    policyNo = '', documentType = '', documentID = '', documentDob = '', policyType = '', captchaToken = '',
  } = submitValues;

  dob = dob || documentDob || dateOfBirth;
  policy = policy || policyNo || policyNumber;
  cardType = cardType || documentType;

  let body;
  const featureName = 'user';
  const documentTypes = {
    hkid: 'hkId',
    chinaId: 'chinaId',
    passport: 'passport',
    axa: 'axa',
    other: 'other',
  };
  if (submitValues.policyType === 'individual') {
    let documentId = documentID || hkId || passport || chinaid;
    documentId = (documentId ? documentId.trim() : documentId);
    body = {
      policyType: 'individual',
      documentType: documentTypes[cardType],
      documentID: documentId,
      dateOfBirth: dob,
      featureName,
      captchaToken,
    };
  } else if (submitValues.policyType === 'pnc') {
    body = {
      policyType,
      documentType: documentTypes[cardType],
      documentID,
      dateOfBirth: dob,
      featureName,
      captchaToken,
      policyNumber: policy,
    };
  } else {
    body = {
      policyType: 'company',
      documentType: documentTypes[cardType],
      ...documentTypes[cardType] === 'axa' ? {
        policyNumber: policy,
        certificateNumber: cert || certificateNumber,
        dependentNumber: dependent || dependentNumber,
      } : {
        membershipNumber: member || membershipNumber,
      },
      dateOfBirth: dob,
      featureName,
      captchaToken,
    };
  }
  return body;
}
export const emmaSubmitForgetUsername = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const currStateVal = getState();
    const currLang = currStateVal.language.lang;
    const body = mapFeToApiField(submitValues);
    dispatch({
      type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START,
    });

    const postBody = {
      resetUserCredentials: {
        ...body,
      },
    };
    const errorHandler = (reasonCode, payload) => {
      let errorCode;
      if (reasonCode) {
        errorCode = reasonCode;
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_FAIL,
          loginId: '',
          errorCode,
          payload: payload || null,
          policyType: submitValues.policyType,
        });
      } else {
        errorCode = 'RESEXP';
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_FAIL,
          loginId: '',
          /** Fix of HKEMMA-60031 */
          // errorCode: 'CUSTOM_ERROR_RETRIEVE_ACCOUNT_GENERAL_ERROR',
          errorCode,
          policyType: submitValues.policyType,
        });
      }

      const errorConfig = getErrorConfig({
        apiCode: errorCode,
        featureCode: FEATURE_CODES.forgetUsername,
        policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
      });

      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
    };

    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };

    await (
      config.isMockResponse ? 
        Promise.resolve((await import('./mocks/retrieveAccount')).default) : 
        muleSoftFetch(`${config.webview.muleApiBaseUrl}/customers/forgot`, 'post', postBody, option))
      .then((res) => {
        const { data } = res;
        if (data.response && data.response.reason) {
          errorHandler(data.response.reasonCode);
          return null;
        }
        if (submitValues.policyType !== POLICY_TYPES.company) {
          const isEmailsUsed = {};
          const isMobilesUsed = {};
          const uniqueMobiles = [...new Set(data.mobiles)];

          for (let i = 0; i < data.isEmailUsed.length; i++) {
            isEmailsUsed[data.isEmailUsed[i].email] = data.isEmailUsed[i].status;
          }

          for (let i = 0; i < uniqueMobiles.length; i++) {
            const countryCodes = data.isMobileUsed.filter(item => item.mobile === uniqueMobiles[i]);
            const countryCodeUsed = {};
            for (let j = 0; j < countryCodes.length; j++) {
              const countryCodeObj = countryCodes[j];
              if (countryCodeObj.countryCode === '') {
                if (countryCodeObj.status === 'Y') {
                  errorHandler('FPEXP11');
                  return null;
                }
              } else {
                countryCodeUsed[countryCodeObj.countryCode] = countryCodeObj.status;
              }
            }
            isMobilesUsed[uniqueMobiles[i]] = countryCodeUsed;
          }

          data.emailMap = [...data.isEmailUsed];
          data.countryCodeMap = [...data.isMobileUsed];

          data.emails = data.emails.map((email, i) => {
            return { [email]: {
              k: email,
              v: isEmailsUsed[email],
              i,
            } };
          });
          data.mobiles = uniqueMobiles.map((mobile, i) => {
            return { [mobile]: {
              k: mobile,
              v: isMobilesUsed[mobile],
              i,
            } };
          });
        }
        return data;
      })
      .then((response) => {
        if (!response) {
          return;
        }
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE,
        });
        if (!response.checkHash) {
          // no check hash return from server
          const errorCode = 'CUSTOM_ERROR_RETRIEVE_ACCOUNT_DONT_MATCH_MDMID';
          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_FAIL,
            axaId: '',
            loginId: '',
            errorCode, // {have no error code} found R16 don't match MDMID,
            policyType: submitValues.policyType,
          });

          const errorConfig = getErrorConfig({
            apiCode: errorCode,
            featureCode: FEATURE_CODES.forgetUsername,
            policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
          });

          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
        } else if (!response.axaId) {
          // no axaId return from server
          const errorCode = 'CUSTOM_ERROR_RETRIEVE_ACCOUNT_MDMID_WITHOUT_AXAID';
          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_FAIL,
            axaId: '',
            loginId: '',
            errorCode, // {have no error code} R17 MDMID without AXAID
            policyType: submitValues.policyType,
          });

          const errorConfig = getErrorConfig({
            apiCode: errorCode,
            featureCode: FEATURE_CODES.forgetUsername,
            policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
          });

          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
        } else if (response.iam) {
          if (response.iam.status.toLowerCase() === 'pre-validated') {
            // account not activate
            const errorCode = 'CUSTOM_ERROR_RETRIEVE_ACCOUNT_INACTIVE_ACCOUNT';

            dispatch({
              type: EMMA_RETRIEVE_ACCOUNT_FAIL,
              axaId: response.axaId,
              loginId: response.iam.loginId,
              errorCode, //  {have no error code} R4 account is inactive
              policyType: submitValues.policyType,
            });

            const errorConfig = getErrorConfig({
              apiCode: errorCode,
              featureCode: FEATURE_CODES.forgetUsername,
              policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
            });

            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
          } else if (response.iam.status.toLowerCase() === 'active') {
            dispatch({
              type: EMMA_RETRIEVE_ACCOUNT_SUCCESS_MULTI_CONTACT,
              hash: response.checkHash,
              emails: response.emails,
              mobiles: response.mobiles,
              isEmailsUsed: response.isEmailUsed,
              isMobilesUsed: response.isMobileUsed,
              loginId: response.iam.loginId,
              policyType: submitValues.policyType,
              emailMap: response.emailMap,
              countryCodeMap: response.countryCodeMap,
              insuredAccessFlag: response.insuredAccessFlag,
              selectContactFlag: response.selectContactFlag,
              lobs: response.lobs,
            });
            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/foundpolicy-success`));
          }
        } else { // fail case
          const errorCode = 'RESEXP';
          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_FAIL,
            axaId: '',
            loginId: '',
            /** Fix of HKEMMA-60031 */
            // errorCode: 'CUSTOM_ERROR_RETRIEVE_ACCOUNT_GENERAL_ERROR',
            errorCode,
            policyType: submitValues.policyType,
          });

          const errorConfig = getErrorConfig({
            apiCode: errorCode,
            featureCode: FEATURE_CODES.forgetUsername,
            policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
          });

          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
        }
      })
      .catch((error) => {
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE,
        });
        if (error.response.data && error.response.data.response && error.response.data.response.reasonCode) {
          const { payload = null } = error.response.data.response || {};

          const errorCode = error.response.data.response.reasonCode;
          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_FAIL,
            loginId: payload ? payload.userContact : '',
            errorCode,
            policyType: submitValues.policyType,
            payload,
          });

          // have policies but none is valid
          if (error.response.data.response.reasonCode === 'POLEXP') {
            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/foundpolicy-success`));
          } else {

            const errorConfig = getErrorConfig({
              apiCode: errorCode,
              featureCode: FEATURE_CODES.forgetUsername,
              policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
            });

            dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
          }
        } else {
          const errorCode = 'RESEXP';

          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_FAIL,
            loginId: '',
            /** Fix of HKEMMA-60031 */
            // errorCode: 'CUSTOM_ERROR_RETRIEVE_ACCOUNT_GENERAL_ERROR',
            errorCode,
            policyType: submitValues.policyType,
          });

          const errorConfig = getErrorConfig({
            apiCode: errorCode,
            featureCode: FEATURE_CODES.forgetUsername,
            policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
          });

          dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
        }
      });
  };
};

export const goToUseOtherUsernamePage = (emmaRetrieveAccount) => {
  return (dispatch, getState) => {
    const { 
      policyType,
      insuredAccessFlag,
      selectContactFlag,
      emails,
      mobiles,
      errorCode,
    } = emmaRetrieveAccount;

    let url = '';
    if ([POLICY_TYPES.individual, POLICY_TYPES.pnc].includes(policyType)) {
      const shouldShowUsernameField = getShouldShowUsernameField(policyType, insuredAccessFlag, selectContactFlag);
      url = shouldShowUsernameField || errorCode === 'POLEXP'
        ? 'emma/forget/username/setup-life-insured'
        : 'emma/forget/username/setup-life';
    } else {
      url = 'emma/forget/username/setup-eb';
    }
    dispatch({
      type: EM_RETRIEVE_ACCOUNT_USE_OTHER_USERNAME,
      emails,
      mobiles,
    });
    const currLang = getState().language.lang;
    dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/${url}`));
  };
};

export const emmaSubmitResetAccount = (submitValues, featureName, shouldShowUsernameField, fromPage) => {
  return async (dispatch, getState) => {
    let details;
    if (shouldShowUsernameField) {
      details = {
        'checkHash': submitValues.hash,
        'contactType': submitValues.contactType,
        ...submitValues.contactType === 'mobile' ? {
          'countryCode': submitValues.countryCode,
          'mobile': submitValues.mobile,
        } : {
          'email': submitValues.email.toLowerCase(),
        },
        'locale': `${getState().language.lang}`,
        'captchaToken': submitValues.captchaToken,
      };
    } else {
      details = {
        'checkHash': submitValues.hash,
        'contactType': submitValues.contactType,
        'contactIndex': submitValues.contactIndex.toString(),
        'locale': `${getState().language.lang}`,
        'captchaToken': submitValues.captchaToken,
      };
    }

    dispatch({
      type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START,
    });
    const queryParams = {
      featureName,
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };

    // // <=== start mock error ===>
    // await Promise.resolve({
    //   response: {
    //     data: {
    //       response: {
    //         reasonCode: 'CUSEXP40'
    //       }
    //     }
    //   }
    // })
    // .then((error) => {
    // //  <=== end mock error ===> 
    await muleSoftFetch(
      parseQueryString(`${config.webview.muleApiBaseUrl}/customers/registration`, queryParams),
      'post',
      { registrationRequest: details },
      option
    ).then(() => {
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE,
        });
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_RESET_SUCCESS,
          loginId: submitValues.contactType === 'email' ? submitValues.email : `${submitValues.countryCode ? submitValues.countryCode : ''}${submitValues.mobile}`,
          contactType: submitValues.contactType,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-success`));
      }).catch((error) => {
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE,
        });

        let errorCode;
        if (error.response.data && error.response.data.response.reasonCode) {
          errorCode = error.response.data.response.reasonCode;
          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_RESET_FAIL,
            errorCode,
            payload: error.response.data.response.payload ? error.response.data.response.payload : null,
          });
        } else {
          errorCode = 'RESEXP';
          dispatch({
            type: EMMA_RETRIEVE_ACCOUNT_RESET_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.forgetUsername,
        });

        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
      });
  };
};

export function sendActivationLink(isPo, captchaToken) {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const { email, contactType, countryCode, mobile } = getState().emmaRetrieveAccount;
    const formData = {
      ...contactType === 'email' ? {
        email: email.toLowerCase(),
      } : {
        countryCode,
        mobile,
      },
      locale: currLang || 'en',
      captchaToken: captchaToken || '',
    };

    dispatch({
      type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START,
    });
    const queryParams = {
      featureName: isPo ? 'reactivateuserPO' : 'reactivateuserCWP',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(
      parseQueryString(`${config.webview.muleApiBaseUrl}/customers/registration`, queryParams),
      'post',
      { registrationRequest: formData },
      option
    ).then(() => {
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE,
        });
        // dispatch({
        //   type: EMMA_REACTIVATE_ACCOUNT_SUCCESS,
        // });
        dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/acc-reactivate-success`));
      }).catch(() => {
        dispatch({
          type: EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE,
        });
        dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/acc-reactivate-fail`));
      });
  };
}

export const reviewSubmitting = (done) => {
  return async (dispatch) => {
    dispatch({
      type: done ? EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_COMPLETE : EMMA_RETRIEVE_ACCOUNT_SERVER_REQUEST_START,
    });
  };
};

export function goBackToFromPage(url = '') {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const fromPageUrl = url || getState().emmaRetrieveAccount.fromPage;
    if (!fromPageUrl) {
      window.history.back();
    }
    dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/${decodeURIComponent(fromPageUrl)}`));
    dispatch({ type: EM_RETRIEVE_ACCOUNT_FROM_CHANGED, fromPage: '' });
  };
}

export function gotoError(code, fromPage = '') {
  return async (dispatch, getState) => {
    dispatch({
      type: EMMA_RETRIEVE_ACCOUNT_RESET_FAIL,
      errorCode: code,
    });

    const errorConfig = getErrorConfig({
      apiCode: code,
      featureCode: FEATURE_CODES.forgetUsername,
    });

    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
  };
}
